import StampIcon from 'assets/icons/stamp.svg';

import React, { FC } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import dayjs from 'dayjs';

interface ImageDetailsProps {
  timestamp?: string | null;
  location?: string | null;
}

export const ImageDetails: FC<ImageDetailsProps> = ({ timestamp, location }) => {
  if (!timestamp && !location) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 16,
        left: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Grid container direction="column" sx={{ gap: '6px' }}>
        {timestamp && (
          <Grid item>
            <Box
              sx={{
                width: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: 'rgba(32, 32, 39, 0.5)',
                opacity: 0.95,
                px: 1,
                py: 0.5,
                borderRadius: 1,
              }}
            >
              <StampIcon />
              <Typography
                variant="caption"
                sx={{
                  fontFamily: 'Inter',
                  fontSize: '10px',
                  fontWeight: '500',
                  lineHeight: '148%',
                  color: '#fff',
                }}
              >
                {dayjs(timestamp).format('LLLL')}
              </Typography>
            </Box>
          </Grid>
        )}

        {location && (
          <Grid item>
            <Box
              sx={{
                width: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: 'rgba(32, 32, 39, 0.5)',
                opacity: 0.95,
                px: 1,
                py: 0.5,
                borderRadius: '6px',
              }}
            >
              <StampIcon />
              <Typography
                variant="caption"
                sx={{
                  fontFamily: 'Inter',
                  fontSize: '10px',
                  fontWeight: '500',
                  lineHeight: '148%',
                  color: '#fff',
                }}
              >
                {location}
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
